// extracted by mini-css-extract-plugin
export default {"wrapper":"MapPOIS_wrapper__+LZXh","map_title_style":"MapPOIS_map_title_style__z66l1"};